@if (loading.loading()) {
  <div class="flex flex-col items-center justify-center h-screen bg-background">
    <img src="icons/blue-owl-horizontal.svg" alt="Blue Owl" class="h-12 mb-8" width="232" height="48">
    <app-tennis-spinner size="xlarge" class="relative -top-20 left-6" />
    <p class="text-sm text-muted-foreground -mt-16">{{ loading.message() }}<span class="animated-dots inline-block w-4 text-left"></span></p>
  </div>
}
<router-outlet />
